/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AssetFilterConditionDto } from './AssetFilterConditionDto';
import type { CriticalityFilterConditionDto } from './CriticalityFilterConditionDto';
import type { DataProductFilterConditionDto } from './DataProductFilterConditionDto';
import type { DatasetNameFilterConditionDto } from './DatasetNameFilterConditionDto';
import type { RuleTemplateNameFilterConditionDto } from './RuleTemplateNameFilterConditionDto';
import type { SourceFilterConditionDto } from './SourceFilterConditionDto';
import type { TagFilterConditionDto } from './TagFilterConditionDto';

export type FilterConditionGroupDto = {
    conditions: Array<(AssetFilterConditionDto | CriticalityFilterConditionDto | DataProductFilterConditionDto | DatasetNameFilterConditionDto | RuleTemplateNameFilterConditionDto | SourceFilterConditionDto | TagFilterConditionDto)>;
    filterLogicalOperator: FilterConditionGroupDto.filterLogicalOperator;
};

export namespace FilterConditionGroupDto {

    export enum filterLogicalOperator {
        AND = 'AND',
        OR = 'OR',
    }


}
